import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class ReferralSettlementMeta extends BaseEntityModel {
  parentId?: number;
  deceasedContactId?: number;

  constructor(model: Partial<ReferralSettlementMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.deceasedContactId = model.deceasedContactId;
  }
}
